export default __webpack_public_path__ + "static/media/HelveticaNeueLTW1G-Th.4975c73d.ttf";